import React from 'react'
import { usePostRequest } from '../hooks/request'
import { INCOME_TAX_LIST } from '../urls'
import IncomeTaxForm from './IncomeTaxForm'

export default function IncomeTaxCreate({ onCancel, onSuccess }) {
    const rotationCreate = usePostRequest({ url: INCOME_TAX_LIST })

    async function onSubmit(data, actions) {
        const { success } = await rotationCreate.request({ data })

        if (success) {
            onSuccess()
            actions.resetForm()
        }
    }

    return (
        <div>
            <b>Добавить</b><br /><br />
            <IncomeTaxForm onSubmit={onSubmit} onCancel={onCancel} loading={rotationCreate.loading} />
        </div>
    )
}
